import React, { Component } from "react";

export default class LoadingSpinner extends Component {
    render() {
        return (
            <div className="d-flex align-items-center">            
                <div className="spinner-grow text-primary" role="status" aria-hidden="true"></div>
                <div className="m-1"><strong>{this.props.loadingText ? this.props.loadingText : 'Loading...'}</strong></div>
            </div>
        );
    }
}